import { navigate } from 'raviger'

import {
  focusLabel,
  formatDuration,
  intensityLabel,
  typeLabel
} from '../utils/workout'

export function WorkoutMeta({ workout }) {
  return (
    <ul class="pills">
      <li class="pill">{typeLabel(workout.type)}</li>
      <li class={`pill intensity-${workout.intensity}`}>
        Intensidad {intensityLabel(workout.intensity).toLowerCase()}
      </li>
      <li class="pill">{formatDuration(workout.durationS)} min</li>
      {workout.bodyFocus && (
        <li class="pill">{focusLabel(workout.bodyFocus)}</li>
      )}
    </ul>
  )
}

function formatDate(iso) {
  return new Date(iso + 'T00:00:00').toLocaleDateString('es-ES', {
    day: 'numeric',
    month: 'long'
  })
}

function OutsideChallenge({ calendar }) {
  const started = new Date() >= new Date(calendar.start + 'T00:00:00')

  return (
    <section class="workout-card">
      <p class="muted">
        {started
          ? 'El reto ha terminado. ¡Gracias por participar!'
          : `El reto empieza el ${formatDate(calendar.start)}.`}
      </p>
    </section>
  )
}

export function WorkoutCard({ today, calendar, streak }) {
  if (!today)
    return <OutsideChallenge calendar={calendar} />

  const { day, workout, play } = today
  if (!workout)
    return (
      <section class="workout-card">
        <h2>Día {day}</h2>
        <p class="muted">Hoy no hay workout en el catálogo.</p>
      </section>
    )

  const done = calendar.doneToday
  const started = play && !play.completedAt

  return (
    <section class={`workout-card${done ? ' done' : ''}`}>
      <p class="workout-day muted">Día {day} de {calendar.days.length}</p>
      <h2>{workout.title}</h2>
      <WorkoutMeta workout={workout} />
      {done ? (
        <p class="workout-done">
          ¡Hecho! Llevas una racha de <strong>{streak}</strong>{' '}
          {streak === 1 ? 'día' : 'días'}.
        </p>
      ) : (
        <button class="primary big" onClick={() => navigate('/play')}>
          {started ? 'Continuar' : 'Empezar'}
        </button>
      )}
    </section>
  )
}
